<div class="change-meal-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="change-meal-nav-bar box">
    <div class="change-meal-nav-bar-title">تعویض پکیج</div>
    <div class="change-meal-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="change-meal-top box">
    <div class="change-meal-input-holder">
      <img src="assets/general/search.svg" />
      <input
        type="text"
        id="changeMealInput"
        [(ngModel)]="searchText"
        placeholder="جستجو"
        (ngModelChange)="search()"
      />
      <div
        class="change-meal-search-remove"
        *ngIf="searchText"
        (click)="clearSearchText()"
      >
        <img src="assets/general/close.svg" />
      </div>
    </div>
  </div>
  <p *ngIf="searchedMeals.length === 0 && searchText" class="center-text">
    غذای مورد نظر یافت نشد
  </p>
  <p *ngIf="!searchText && recentSearches.length === 0" class="center-text">
    غذای مورد نظر خود را جستجو کنید
  </p>
  <div class="tableView" *ngIf="searchedMeals.length !== 0">
    <table class="table table-striped">
      <tbody>
        <tr
          *ngFor="let meal of searchedMealsFoodsName; let i = index"
          (click)="mealDetail(i)"
        >
          <td>
            <div class="table-row-title">
              {{ meal }}
            </div>
            <img class="table-row-icon" src="assets/general/left-gray.svg" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="tableView"
    *ngIf="recentSearches.length !== 0 && !searchText"
    style="border-top: none"
  >
    <div class="recently-title">اخیرا</div>
    <table class="table table-striped">
      <tbody>
        <tr
          *ngFor="let recently of recentSearchesFoodsName; let i = index"
          (click)="mealDetailRecently(i)"
        >
          <td>
            <div class="table-row-title">
              {{ recently }}
            </div>
            <img class="table-row-icon" src="assets/general/left-gray.svg" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-bottomsheet *ngIf="showDetail" [type]="'mealDetail'"></app-bottomsheet>
</div>
